import { IconProps } from '../icon-props-interface';
import '../icons.scss';

export const IconCircleEmail = ({ color = 'var(--color-accent-1)' }: IconProps): JSX.Element => (
    <div className="icon-block">
<svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="11.25" cy="11" r="11" fill={color}/>
<path d="M6.25 7V15H17.25V7H6.25ZM11.7461 11.8105L7.284 7.61538H16.2264L11.7461 11.8105ZM9.97382 11.0098L6.89706 13.8911V8.11692L9.97382 11.0098ZM10.4339 11.4425L11.7448 12.6751L13.0364 11.4652L16.1422 14.3846H7.29241L10.4339 11.4425ZM13.4977 11.0338L16.6029 8.12615V13.952L13.4977 11.0338Z"
      fill="white"/>
</svg>
    </div>
);

export default IconCircleEmail;
